import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import styles from './IconPaykeeper.module.css';
import icon from './pay_keeper.svg';

import type { FC, HTMLAttributes } from 'react';

export interface IconProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const IconPaykeeper: FC<IconProps> = ({ className }) => {
  return (
    <Img
      src={icon}
      className={cn(styles.icon, className)}
      alt='Принимаем оплату банковскими картами PayKeeper'
    />
  );
};

export default memo(IconPaykeeper);
